import { NavBar, WeatherCard, WetherStatsCard, Graph } from "./components";
import { format, addDays } from "date-fns";
import "./home.css";
import useHomeViewModal from "./homeViewModal";

import AgriRiskCard from "./components/AristickCard";
import ThingspeakCard from "./components/ThingspeadCard";
import Pests from "./components/Warning/Pests";
export default function HomeScreen(): JSX.Element {
  const array = [1, 2, 3, 4];
  const {
    weatherData,
    currentDate,
    handlePrevDate,
    handleNextDate,
    getLastUpdateTime,
    getCurrentDateAndTime,
    stats,
    userData,
    graphData,
    isLoading = true,
    farmerData,
  } = useHomeViewModal();

  return (
    <div style={{ padding: 10 }}>
      <NavBar />
      <div className="card">
        <h2>Farmer Information</h2>
        <p>
          {/* <strong>Farmer Name:</strong> {farmerData.farmerName} */}
          <strong>Farmer Name:</strong> Hemant Singh
        </p>
        <p>
          {/* <strong>Village:</strong> {farmerData.village} */}
          <strong>Village:</strong> Barbakpur
        </p>
        <p>
          <strong>Coordinates:</strong> {farmerData.coordinates.latitude},{" "}
          {farmerData.coordinates.longitude}
        </p>
        <p>
          {/* <strong>Crop:</strong> {farmerData.crop} */}
          <strong>Crop:</strong> Wheat
        </p>
        <p>
          <strong>Area:</strong> {farmerData.area}
        </p>
        <p>
          <strong>Date of Sowing:</strong> {farmerData.sowingDate}
        </p>
      </div>
      <div>
        <h2
          style={{
            textAlign: "center",
            marginTop: "20px",
            marginBottom: "10px",
          }}
        >
          Dough Stage
        </h2>
      </div>
      <div>
        <h2>Weather Report</h2>
      </div>
      <div className="weatherCardContainer">
        <WeatherCard
          weatherData={weatherData}
          getLastUpdateTime={getLastUpdateTime}
          getCurrentDateAndTime={getCurrentDateAndTime}
        />
        <div className="weatherStats">
          {Object.keys(stats).map(
            (element: any, index: number): JSX.Element => {
              return (
                <WetherStatsCard
                  key={index}
                  title={element}
                  data={stats[element]}
                  icon=""
                />
              );
            },
          )}
        </div>
      </div>
      {/*<div className="RepordHeader">
        <h2>
     
          Agristick Data Report
          <div className="dateDisplay">
            <button onClick={handlePrevDate}>&lt;</button>
            <span>{format(currentDate, "dd/MM/yyyy")}</span>
            <span> -</span>
            <span>{format(addDays(currentDate, 6), "dd/MM/yyyy")}</span>
            <button onClick={handleNextDate}>&gt;</button>
          </div>
        </h2>

        <div className="graphs">
          <Graph
            title={"Soil Mostiure"}
            data={graphData}
            x={"day"}
            loading={isLoading}
            y={"averageSoilMoisture"}
          />
          <Graph
            title={"Leaf Wetness"}
            data={graphData}
            x={"day"}
            loading={isLoading}
            y={"averageLeafWetness"}
          />
        </div> 
      </div>*/}
      <ThingspeakCard />
      <Pests />
      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        <AgriRiskCard
          type="Pest"
          diseaseName="Powdery Mildew"
          imageUrl="https://agrichikitsabucket.s3.ap-south-1.amazonaws.com/1749392793293-144166607"
          percentage={10}
          riskLevel="ok"
        />
        <AgriRiskCard
          type="Pest"
          diseaseName="Powdery Mildew"
          imageUrl="https://agrichikitsabucket.s3.ap-south-1.amazonaws.com/1749392793293-144166607"
          percentage={52}
          riskLevel="medium"
        />
        <AgriRiskCard
          type="Pest"
          diseaseName="Powdery Mildew"
          imageUrl="https://agrichikitsabucket.s3.ap-south-1.amazonaws.com/1749392793293-144166607"
          percentage={95}
          riskLevel="not_ok"
        />
        <AgriRiskCard
          type="Disease"
          diseaseName="Powdery Mildew"
          imageUrl="https://agrichikitsabucket.s3.ap-south-1.amazonaws.com/1749392793293-144166607"
          percentage={95}
          riskLevel="not_ok"
        />
      </div> */}
    </div>
  );
}
